import React from 'react';
import PropTypes from 'prop-types';
import memoizeOne from 'memoize-one';
import { Droppable } from 'react-beautiful-dnd';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import BackglogTask from './BacklogTask';

const styles = theme => ({
    containerElement: {
        margin: 10,
        border: '1px solid #090909',
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
    scrollArea: {
        flexGrow: 1,
    },
    taskListElement: {
        transition: 'background-color 0.2s ease',
        flexGrow: 1,
    }
});
const getSelectedMap = memoizeOne((selectedTaskIds) =>
    selectedTaskIds.reduce((previous, current) => {
        previous[current] = true;
        return previous;
    }, {}),
);

class BacklogList extends React.Component {
    render() {
        const { classes, column, tasks, selectedTaskIds, draggingTaskId } = this.props;
        return (<div className={classes.containerElement}>
            <AppBar position="static" color="default" elevation={0}>
                <Toolbar>
                    <Typography align="center" variant="headline" component="h2">
                        {column.title}
                    </Typography>
                </Toolbar>
            </AppBar>
            <Droppable droppableId={column.id}>
                {
                    (provided, snapshot) => (
                        <div className={classes.taskListElement} ref={provided.innerRef} {...provided.droppableProps} >
                            {
                                tasks.map((task, index) => {
                                    const isSelected = Boolean(getSelectedMap(selectedTaskIds)[task.id]);
                                    const isGhosting = isSelected && Boolean(draggingTaskId) && draggingTaskId !== task.id;
                                    return (
                                        <BackglogTask task={task} index={index} key={task.id} isSelected={isSelected}
                                            isGhosting={isGhosting} selectionCount={selectedTaskIds.length}
                                            toggleSelection={this.props.toggleSelection} userAssignmentHandler={this.props.userAssignmentHandler}
                                            toggleSelectionInGroup={this.props.toggleSelectionInGroup}
                                            multiSelectTo={this.props.multiSelectTo} />
                                    );
                                })
                            }
                            {provided.placeholder}
                        </div>
                    )
                }
            </Droppable>
        </div >)
    }
}

BacklogList.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles, { withTheme: true })(BacklogList);


// WEBPACK FOOTER //
// ./src/Components/Presentation/BacklogTasks/BacklogList.js